import { memo, type ChangeEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import type { Props } from './types';

const NavSelect = ({ navOptions, selectedValue, defaultOption }: Props) => {
  const navigate = useNavigate();

  const handleOption = (event: ChangeEvent<HTMLSelectElement>) => {
    const { value } = event.target;
    navigate(navOptions[value]);
  };

  return (
    <select
      aria-label="Select page"
      className="py-1 px-2 border border-gray-300 bg-white rounded-md shadow-xs focus:outline-hidden focus:ring-indigo-500 focus:border-indigo-500"
      id="id-select-person-page"
      onChange={handleOption}
      value={selectedValue}>
      {defaultOption?.label && defaultOption.value && (
        <option value={defaultOption.value}>{defaultOption.label}</option>
      )}

      {Object.keys(navOptions)
        .sort()
        .map((option) => {
          return (
            <option key={`nav-select-${option}`} value={option}>
              {option}
            </option>
          );
        })}
    </select>
  );
};

export default memo(NavSelect);
